export default "__VITE_ASSET__5936128e__"